import TeamMobile from "../../../assets/images/MVteam.png";
import TeamDT from "../../../assets/images/DVteam.png"
import landingDesktop from "../../../assets/images/why-zoee-landing-desktop-comp.webp";
import landingMobile from "../../../assets/images/why-zoee-landing-mobile-comp.webp";
import zoeeLogoOutline from "../../../assets/images/zoee-logo-outline-square.webp";
import zoeeLogoOutlineFullText from "../../../assets/images/zoee-logo-outline-full-text.webp";
import signature from "../../../assets/images/nichole-lowe-signature.webp";
import nichole from "../../../assets/images/nichole-lowe.webp";

import { Button } from "../../../components/ui/button";

export default function WhyZoeePage() {
  return (
    <div className="relative mx-auto mt-[88px] max-w-screen-2xl overflow-hidden">
      <div>
        <img
          className="hidden max-h-[990px] min-h-[698px] object-cover sm:block"
          src={landingDesktop}
          alt="a group of excited coaches and Zoee team members"
        />
        <img
          className="min-h-[698px w-full object-cover sm:hidden"
          src={landingMobile}
          alt="a group of excited coaches and Zoee team members"
        />
      </div>

      <div className="mx-[24px] -translate-y-[320px] rounded-t-xl bg-white px-[12px] pb-[28px] pt-[42px] sm:mx-[80px] sm:px-[40px] md:mx-[60px] md:-translate-y-[140px] md:px-[40px] lg:mx-[120px] lg:px-[100px] lg:pt-[80px] xl:-translate-y-[174px]">
        <h2 className="mb-[24px] text-[58px] font-bold leading-[103%] md:text-[64px] xl:text-[88px]">
          ZOEE IS <br className="md:hidden" /> HERE TO
          <br />
          <div className="block ">
            <span className="text-blurple">UPLIFT</span> HUMANITY
          </div>
        </h2>

        <p className="mb-[24px] text-[18px]">
          Through tech that offers back-office solutions, Zoee is an all in one
          platform built by coaches, for coaches. In sum, we are in the business
          of helping you run wildly successful businesses by offering guidance,
          support, technology, and community. Zoee is a place for coaches to
          call home, but we aren&apos;t stopping there.
        </p>
        <p className="text-[18px]">
          In fact, we&apos;re just getting started. Zoee is excited to welcome
          members (those looking for coaches) to the platform later this year.
          At that time, we&apos;ll also be launching our Marketplace, where
          coaches and members can get matched with one another. This means we
          can all spend less time scrolling through coach websites, and more
          time making meaningful connections in coaching calls.
        </p>
      </div>

      <section className="relative xl:min-h-[1280px] lg:min-h-[1100px] gray-background-gradient translate-y-[-160px] md:translate-y-[-60px] pt-[60px] px-[24px]">
        <h2 className="text-[54px] md:text-[88px] font-bold text-center">Who We Are</h2>
        <p className="content-center max-w-[622px] mx-auto shrink">
          We are a team of dedicated professionals working to make the world a better place.
          Through tech that simplifies not only the back-office of a coaching business, but hosts
          an ecosystem for coaches to connect with one another, Zoee is here to change your
          life—and the world.
        </p>
        <div className="flex lg:hidden w-[100%] mt-[36px] mb-[54px] justify-center mx-auto">
          <img src={TeamMobile} alt="the Zoee team" />
        </div>
        <div className="lg:block hidden  relative top-[60px] grow mx-auto left-0 right-0">
          <img src={TeamDT} alt="the Zoee team" />
        </div>
        <div className="content-center top-[25%]  max-w-[622px] mx-auto">
          <p className="mb-[24px]">
            We are digital nomads, firmly rooted families, Gen Zs, Baby Boomers, and
            everything in between. We are a team that celebrates the small wins, the big
            wins, the solved problems, and the hilarious Slack messages.
          </p>
          <p className="mb-[24px]">
            We work hard, we don&apos;t give up, and we love what we do. Here at Zoee, there
            are real humans behind the tech, the marketing materials, and the emails you
            receive. We are real people making real change in the lives of our members.
          </p>
          <p className="mb-[32px]">
            Come join us on this journey—we&apos;d love to add another member to the Zoee
            community.
          </p>
          <div className="justify-items-center">
            <Button
              size="lg"
              asChild
            >
              <a href="mailto:hello@zoee.com">Join Team Zoee</a>
            </Button>
          </div>

        </div>
      </section>

      <section className="relative md:px-auto sm:px-[48px] px-[24px] md:pb-[240px] pb-[180px] mt-[120px] text-[18px] overflow-hidden">
        <img
          className="absolute md:top-[48px] top-[-20px] md:right-[-93px] right-[-200px] md:h-auto h-[110px]"
          src={zoeeLogoOutlineFullText}
          alt="outline of zoee logo"
        />
        <h2 className="xl:ml-[204px] lg:ml-[84px] md:ml-[0px] mb-[76px] max-w-[676px] font-bold text-[54px] leading-[63px] lg:leading-[103px] lg:text-[80px]">
          A Letter from the Founder &amp; CEO
        </h2>

        <div>
          <div className="md:mx-auto md:max-w-[816px]">
            <p className="mb-[24px]">
              Success does not happen alone. No journey, in business or life, was meant to
              be a solo one.
            </p>
            <p className="mb-[24px]">I founded Zoee to embody those ideals.</p>
            <p className="mb-[48px]">
              As an entrepreneur and a certified coach myself, I recognized how difficult
              it was to build and run a thriving coaching business without the proper
              tools. Despite the demand and astounding growth in the industry, the
              coaching community has been woefully underserved, overlooked, and
              underestimated.
            </p>
          </div>

          <div className="lg:flex lg:max-w-[816px] lg:gap-[42px] lg:mx-auto lg:w-full lg:justify-center">
            <div className="lg:hidden mb-[48px] font-semibold text-[30px] italic leading-[36px] flex justify-center gap-[4px]">
              <div>“</div>
              <div className="max-w-[324px]">
                I made it my mission to liberate each entrepreneur from daily drudgery
                to focus on their clients and their own success.
              </div>
            </div>

            <div className="lg:max-w-[432px]">
              <p className="mb-[24px]">
                I set out to provide what was missing from this industry. How could I
                make the path forward easier for others? What tools would have helped me
                the most? Could I make those available to other coaches to help them
                win, too?
              </p>
              <p className="mb-[24px]">
                I made it my mission to liberate each entrepreneur from daily drudgery
                to focus on their clients and their own success.
              </p>
            </div>

            <div className="hidden translate-x-[60px] lg:flex mb-[48px] font-semibold text-[30px] italic leading-[36px] justify-center gap-[4px]">
              <div>“</div>
              <div className="max-w-[324px]">
                I made it my mission to liberate each entrepreneur from daily drudgery
                to focus on their clients and their own success.
              </div>
            </div>
          </div>

          <div className="lg:mx-auto lg:max-w-[816px]">
            <p className="mb-[24px]">
              Time is the most valuable asset to any entrepreneur and if I could give that
              back, I could transform lives—and the industry.
            </p>
            <p className="mb-[48px]">
              What coaches needed was a single solution to match with potential clients
              and to manage their business.
            </p>
          </div>

          <div className="lg:flex lg:gap-[32px] lg:mx-auto lg:w-full lg:justify-center">
            <div className="lg:w-[408px] lg:h-[176px] lg:translate-x-[-60px] mb-[48px] font-semibold text-[30px] italic leading-[36px] flex justify-center gap-[4px]">
              <div>“</div>
              <div className="lg:max-w-[408px] max-w-[324px]">
                Time is the most valuable asset to any entrepreneur and if I could give
                that back, I could transform lives—and the industry.
              </div>
            </div>

            <div className="lg:max-w-[440px]">
              <p className="mb-[24px]">
                I decided to solve this problem and share my knowledge to empower other
                coaches to have access to what they need so they too could make their
                business wildly successful.
              </p>
              <p className="mb-[24px]">
                My focus was not only to improve the individual experience of
                establishing and running a coaching business, but to provide a greater
                sense of community for coaches and clients alike.
              </p>
            </div>
          </div>

          <div className="lg:mx-auto lg:max-w-[816px]">
            <h4 className="mb-[24px] text-[30px] font-semibold italic">Zoee was born.</h4>

            <p className="mb-[24px]">
              The company would be more than just my knowledge and experience, it would be
              the sum total of all of us supporting each other on this amazing adventure.
            </p>

            <p className="mb-[24px]">
              It&apos;s been an incredible journey, and we're just getting started!
            </p>
          </div>

          <div className="md:mt-[200px] mt-[100px] flex flex-col justify-center md:items-center md:flex-row md:gap-[64px]">
            <div>
              <h5 className="font-bold text-[24px]">Nichole Lowe</h5>
              <img className="mb-[24px]" src={signature} alt="Nichole Lowe signature" />
            </div>
            <img
              className="w-[280px] h-[280px]"
              src={nichole}
              alt="Zoee Founder and CEO Nichole Lowe"
            />
          </div>
        </div>
      </section>
      <div className="gray-background-gradient text-grayCharcoal relative flex w-full flex-col items-center justify-center px-[24px] py-[180px] font-bold">
        <img
          className="absolute top-[-72px] z-0 hidden md:left-[140px] md:block xl:left-[242px]"
          src={zoeeLogoOutline}
          alt="zoee logo outline"
        />
        <div>
          <h4 className="mb-[16px] text-[40px] sm:text-[48px]">
            Want to join team Zoee?
          </h4>
          <p className="mb-[32px] max-w-[388px] text-[22px]">
            If you&apos;re interested in a career at Zoee, we&apos;d love to
            hear from you.
          </p>
          <Button
            size="lg"
            asChild
          >
            <a href="mailto:hello@zoee.com">Join Team Zoee</a>
          </Button>
        </div>
      </div>
    </div>
  );
}